import { withDefaultTradersDates } from "./b2bDates";
import { apiClient } from "./client";
import { fetchB2BTradersDatasetViaExpo, shouldFallbackTradersRequest } from "./b2bTradersFallback";
import type {
    B2BDatasetResponse,
    B2BExpoDatasetResponse,
    B2BTradersDatasetParams,
    B2BTradersDatasetResponse,
} from "./types";

export type B2BDatasetParams = {
    noOrderDays?: number;
};

export async function fetchB2BDataset(params: B2BDatasetParams = {}) {
    const response = await apiClient.get<B2BDatasetResponse>("/b2b", {
        params: params.noOrderDays ? { no_order_days: params.noOrderDays } : {},
    });

    return response.data;
}

export type B2BExpoDatasetParams = {
    dateFrom?: string;
    dateTo?: string;
    traderName?: string;
    traderUserId?: number;
    routesPage?: number;
    routesPerPage?: number;
    performancePage?: number;
    performancePerPage?: number;
};

export async function fetchB2BExpoDataset(params: B2BExpoDatasetParams = {}) {
    const normalized = withDefaultTradersDates(params);

    const response = await apiClient.get<B2BExpoDatasetResponse>("/b2b/expo", {
        params: {
            date_from: normalized.dateFrom,
            date_to: normalized.dateTo,
            ...(params.traderName ? { trader_name: params.traderName } : {}),
            ...(params.traderUserId ? { trader_user_id: params.traderUserId } : {}),
            routes_page: params.routesPage ?? 1,
            routes_per_page: params.routesPerPage ?? 10,
            performance_page: params.performancePage ?? 1,
            performance_per_page: params.performancePerPage ?? 10,
        },
    });

    return response.data;
}

function tradersRequestParams(params: B2BTradersDatasetParams) {
    return {
        date_from: params.dateFrom,
        date_to: params.dateTo,
        ...(params.traderName ? { trader_name: params.traderName } : {}),
        ...(params.traderUserId ? { trader_user_id: params.traderUserId } : {}),
        page: params.page ?? 1,
        per_page: params.perPage ?? 10,
    };
}

export async function fetchB2BTradersDataset(params: B2BTradersDatasetParams = {}) {
    const normalized = withDefaultTradersDates(params);

    try {
        const response = await apiClient.get<B2BTradersDatasetResponse>("/b2b/traders", {
            params: tradersRequestParams(normalized),
        });

        return response.data;
    } catch (error) {
        if (shouldFallbackTradersRequest(error)) {
            return fetchB2BTradersDatasetViaExpo(normalized);
        }

        throw error;
    }
}
